"use strict";

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var w3c_keys_1 = require("w3c-keys");

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Indicator_1 = require("../_Indicator/Indicator");

var Item_1 = require("./Item");

var TabBar =
/** @class */
function (_super) {
  __extends(TabBar, _super);

  function TabBar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = _this.props.id || uniqid_1["default"]("tabs-");

    _this.onResize = function () {
      _this.updateItemsFitting();
    };

    _this.areItemsNotFitting = function () {
      if (_this.containerElm) {
        var items = _this.containerElm.querySelectorAll("." + CSSPrefix_1.lsgPre + "tabbar-item");

        var tabElementsWidth = items.length ? Array.from(items).map(function (tabElement) {
          return tabElement.offsetWidth;
        }).reduce(function (result, current) {
          return result + current;
        }) : 0;
        var containerStyles = window.getComputedStyle(_this.containerElm);
        var availableSpace = parseInt(containerStyles.width, 10) - (_this.secondaryItemsElm ? _this.secondaryItemsElm.offsetWidth : 0);
        return tabElementsWidth > availableSpace;
      }
    };

    _this.updateItemsFitting = function () {
      var itemsNotFitting = _this.areItemsNotFitting();

      if (_this.props.onItemsDontFit && _this.previousItemsDontFit !== itemsNotFitting) {
        _this.props.onItemsDontFit(!itemsNotFitting);
      }

      _this.previousItemsDontFit = itemsNotFitting;
    };

    _this.handleKeyDown = function (event) {
      var openIndex = _this.props.openIndex >= 0 ? _this.props.openIndex : 0;

      switch (event.key) {
        case w3c_keys_1.Key.ArrowRight:
        case w3c_keys_1.Key.ArrowDown:
          event.preventDefault();
          openIndex = openIndex + 1 > _this.numTabs - 1 ? 0 : openIndex + 1;
          break;

        case w3c_keys_1.Key.ArrowLeft:
        case w3c_keys_1.Key.ArrowUp:
          event.preventDefault();
          openIndex = openIndex - 1 < 0 ? _this.numTabs - 1 : openIndex - 1;
          break;

        case w3c_keys_1.Key.Home:
          event.preventDefault();
          openIndex = 0;
          break;

        case w3c_keys_1.Key.End:
          event.preventDefault();
          openIndex = _this.numTabs - 1;
          break;

        default:
          break;
      }

      if (_this.props.onKeyDown) _this.props.onKeyDown(openIndex, event);
    };

    return _this;
  }

  TabBar.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addResizeCallback(this.onResize);
    this.updateItemsFitting();
  };

  TabBar.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeResizeCallback(this.onResize);
  };

  TabBar.prototype.componentDidUpdate = function () {
    // set focus only if some tab other than the active tab is in focus
    if (!this.props.focusAllItems && this.hasFocus && this.selectedTabElm && this.selectedTabElm !== document.activeElement) {
      this.selectedTabElm.focus();
    }
  };

  TabBar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        role = _a.role,
        openIndex = _a.openIndex,
        stacked = _a.stacked,
        focusAllItems = _a.focusAllItems;
    this.numTabs = React.Children.toArray(children).length;
    this.hasFocus = false;
    var marginTop = stacked && this.containerElm ? "-" + this.containerElm.offsetHeight * openIndex + "px" : 0;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "tabbar", className, (openIndex === undefined || openIndex < 0) && CSSPrefix_1.lsgPre + "tabbar__closed", stacked && CSSPrefix_1.lsgPre + "tabbar__stacked"]),
      id: this.uuid,
      // ref methods in react seem to be called twice on every render - in the first call "r" is set, in the second "r" is null, so it overrides the set containerRef every time
      // it would work fine within this component, but the ref-callback passed to <Indicator> will always return null
      ref: function ref(r) {
        if (r) _this.containerElm = r;

        _this.props.refCallback(r);
      }
    }, React.createElement("ul", {
      role: role,
      "aria-orientation": "horizontal",
      className: CSSPrefix_1.lsgPre + "tabbar-tablist",
      style: {
        marginTop: marginTop
      }
    }, React.Children.toArray(children).map(function (child, i) {
      var active = openIndex === i;
      return React.createElement(TabBar.Item, __assign({}, child.props, {
        active: active,
        key: _this.uuid + "-item-" + child.props.label,
        refCallback: function refCallback(r) {
          if (active) {
            _this.selectedTabElm = r;
          } else {
            _this.hasFocus = _this.hasFocus || r === document.activeElement;
          }

          child.props.refCallback(r);
        },
        id: child.props.id || _this.uuid + "-item-" + i,
        htmlAttrs: __assign(__assign({}, child.props.htmlAttrs), {
          tabIndex: focusAllItems || active || openIndex < 0 && i === 0 ? 0 : -1,
          onKeyDown: _this.handleKeyDown
        })
      }));
    })), this.props.secondaryItems && React.createElement("div", {
      ref: function ref(r) {
        return _this.secondaryItemsElm ? _this.secondaryItemsElm : _this.secondaryItemsElm = r;
      },
      className: CSSPrefix_1.lsgPre + "tabbar-secondary-items"
    }, this.props.secondaryItems), React.createElement(Indicator_1.Indicator, {
      selectedItemRefCallback: function selectedItemRefCallback() {
        return _this.selectedTabElm;
      },
      containerRefCallback: function containerRefCallback() {
        return _this.containerElm;
      },
      fullSizeWhenUnselected: this.props.fullIndicatorWhenUnselected,
      horizontal: true,
      hide: this.areItemsNotFitting,
      withHelperLine: this.props.indicatorHelperLine
    }));
  };

  TabBar.Item = Item_1.Item;
  TabBar.defaultProps = {
    onKeyDown: function onKeyDown() {
      /* empty */
    },
    onItemsDontFit: function onItemsDontFit() {
      /* empty */
    },
    refCallback: function refCallback() {
      /* empty */
    }
  };
  return TabBar;
}(React.Component);

exports.TabBar = TabBar;